import { DEVICE_WIDTH } from '@/constants';

// 返回根元素fontsize
export const getDeviceRatio = () => {
  return Math.min(100, 100 * (window.document.body.clientWidth / DEVICE_WIDTH));
};
